// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero-banner-v2--authoring .heroCardsContentWrapper{height:500px}.hero-banner-v2--authoring .heroCardsContentWrapper .imageWrapper{height:100%}.hero-banner-v2--authoring .authorWrapperGlobal{position:relative;height:auto;margin-bottom:60px}", ""]);
// Exports
module.exports = exports;
